import { useEffect, useState } from 'react';

type TUseMaxHeightToBottomResponse = {
  height: number;
};

type TUseMaxHeightToBottomParams = {
  initialHeight?: number;
  onlyIf?: boolean;
  paddingBottom?: number;
  elementId: string;
};

export const useMaxHeightToBottom = (
  {
    initialHeight = 600,
    onlyIf = true,
    paddingBottom = 20,
    elementId,
  }: TUseMaxHeightToBottomParams = {
    elementId: '',
  }
): TUseMaxHeightToBottomResponse => {
  const [height, setHeight] = useState<number>(initialHeight);
  const [render, setRender] = useState<boolean>(false);

  useEffect(() => {
    if (render && onlyIf) {
      const element = document.getElementById(elementId);
      const formRect = element?.getBoundingClientRect();
      if (formRect) {
        const heightFromElementToBottom = window.innerHeight - formRect?.top;

        setHeight(heightFromElementToBottom - paddingBottom);
      }
    }
  }, [render, onlyIf, elementId, paddingBottom]);

  useEffect(() => {
    setRender(true);
  }, []);

  return {
    height,
  };
};
